import { Tab } from '@/types';
import { useOrganization } from '@/hooks/useOrganization';
import {
  calculateItemTotal,
  calculateIvaAmount,
  calculateServiceChargeAmount,
  calculateTabSaleTotals,
  calculateTabSubtotal,
  getIvaSettings,
  getServiceChargeSettings,
  toTabTotalsOrgSnapshot,
} from '@/utils/tabTotals';

export const useTabCalculations = () => {
  const { currentOrganization } = useOrganization();
  const orgSnapshot = toTabTotalsOrgSnapshot(currentOrganization);

  const calculateSubtotal = (tab: Tab) => calculateTabSubtotal(tab);

  const calculateServiceCharge = (subtotal: number, tab?: Tab) =>
    calculateServiceChargeAmount(subtotal, tab ?? ({} as Tab), orgSnapshot);

  const calculateIva = (subtotal: number, ivaDisabled: boolean = false) =>
    calculateIvaAmount(subtotal, { ivaDisabled } as Tab, orgSnapshot);

  const calculateTotal = (tab: Tab) => calculateTabSaleTotals(tab, orgSnapshot).total;

  return {
    calculateItemTotal,
    calculateSubtotal,
    calculateServiceCharge,
    calculateTotal,
    getServiceChargeSettings: () => getServiceChargeSettings(orgSnapshot),
    getIvaSettings: () => getIvaSettings(orgSnapshot),
    calculateIva,
  };
};
